export const COMPATIBLEBROWSERWIN = {
    Chrome: 113,
    Edge: 113,
    Firefox: 110,
};
export const COMPATIBLEBROWSERMAC = {
    Chrome: 101,
    Safari: 15,
    Opera: 86,
};
export const COMPATIBLEBROWSERANDRIODMOBILE = {
    Chrome: 108,
    Samsung: 22,
};
export const COMPATIBLEBROWSERIOSMOBILE = {
    Safari: 15,
};
export const COMPATIBLEBROWSERANDRIODTAB = {
    Chrome: 108,
};
export const COMPATIBLEBROWSERIPAD = {
    Safari: 15,
};
export const SUPPORTEDBROWSERLIST = {
    CHROME: 'Chrome',
    EDGE: 'Edge',
    FIREFOX: 'Firefox',
    SAFARI: 'Safari',
    SAMSUNG: 'Samsung',
    OPERA: 'Opera'
};
export const DEVICETYPE = {
    MOBILE: 'mobile',
    TABLET: 'tablet',
    DESKTOP: 'desktop',
};

export const MAILAPPLICATION = 'Go to Received messages';

export const BROWSERLIST = {
    CHROME: 'https://www.google.com/chrome/',
    EDGE: 'https://www.microsoft.com/en-us/edge/',
    FIREFOX: 'https://www.mozilla.org/en-CA/firefox/new/?xv=refresh-new&v=a',
    SAFARI: 'https://support.apple.com/en-ca/102665',
    CHROME_FR: 'https://www.google.com/intl/fr_ca/chrome/',
    EDGE_FR: 'https://www.microsoft.com/fr-ca/edge/',
    FIREFOX_FR: 'https://www.mozilla.org/fr/firefox/new/?xv=refresh-new&v=b',
    SAFARI_FR: 'https://support.apple.com/fr-ca/102665',
};
